<template>
  <div>
    <div class="fixed-bar">
      <pre-header/>
      <navbar/>
    </div>
    <login-dialog/>
    <memberships-dialog/>
    <memberships-apply-dialog/>
    <memberships-rouji-dialog/>
    <app-main/>
    <layout-footer/>
    <forgot-password/>
    <common-dialog id="sentMembershipsDialog" message="sentmembershipsful"/>
    <common-dialog id="sentMembershipsRoujiDialog" message="snetmembershiprouji"/>
    <div :class="{ 'z-hide': !isloading }" class="load8">
        <b-spinner class="loader"/>
    </div>
  </div>
</template>

<script>
import Navbar from './components/navbar'
import AppMain from './components/app-main'
import PreHeader from './components/preheader'
import LayoutFooter from './components/footer'
import ForgotPassword from '@/components/cn/ForgotPassword'
import MembershipsDialog from '@/components/cn/MembershipsDialog'
import MembershipsApplyDialog from '@/components/cn/MembershipsDialog/apply.vue'
import MembershipsRoujiDialog from '@/components/cn/MembershipsDialog/rouji.vue'
import CommonDialog from '@/components/cn/CommonDialog'
import LoginDialog from '@/components/cn/LoginDialog'

export default {
  name: 'CNLayout',
  components: {
    Navbar,
    AppMain,
    PreHeader,
    LoginDialog,
    CommonDialog,
    LayoutFooter,
    ForgotPassword,
    MembershipsDialog,
    MembershipsRoujiDialog,
    MembershipsApplyDialog
  },
  computed: {
    isloading () {
      return this.$store.getters.isLoading
    }
  },
  mounted () {
    this.$i18n.locale = 'zh-cn'
  }
}
</script>

<style>
.z-hide { display: none }
</style>

<style scoped>

.fixed-bar {
  width: 100%;
  position: fixed;
  z-index: 9;
}

.load8 {
  height: auto !important;
}

.load8 .loader {
  font-size: 1px;
  position: absolute;
  margin: -75px 0 0 -75px;
  top: 50%;
  left: 50%;
  border-top: 3.1px solid rgba(60, 60, 255, 0.5);
  border-right: 3.1px solid rgba(60, 60, 255, 0.5);
  border-bottom: 3.1px solid rgba(60, 60, 255, 0.5);
  border-left: 3.1px solid transparent;
  -webkit-animation: load8 2.1s infinite linear;
  animation: load8 2.1s infinite linear;
  z-index: 9999;
  position: fixed;
}

.load8 .loader,
.load8 .loader:after {
  border-radius: 50% !important;
  width: 150px;
  height: 150px;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>
